/* src/app/warehousing/pages/stock-revaluation/stock-revaluation.component.scss */
/*# sourceMappingURL=stock-revaluation.component.css.map */
